module.exports = __webpack_public_path__ + "public/files/img/results-process.467706a3.gif";